
import '../styles/color-variables.css';

export const customStyles = {
    table: {
        style: {
            border: '1px solid #ddd'
        }
    },
    header: {
        style: {
            minHeight: '56px'
        }
    },
    head: {
        style: {}
    },
    headRow: {
        style: {
            backgroundColor: '#eff2f7'
        }
    },
    headCells: {
        style: {
            '&:not(:last-of-type)': {
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                borderRightColor: '#D4D3D3'
            }
        }
    },
    cells: {
        style: {
            '&:not(:last-of-type)': {
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                borderRightColor: '#D4D3D3'
            }
        }
    },
    progress: {
        style: {
            border: 'transparent'
        }
    }
};

export const customInterspersedStyles = {
    table: {
        style: {
            border: '1px solid #ddd',
            borderRadius: '12px',
            overflow: 'visible'
        }
    },
    header: {
        style: {
            minHeight: '56px'
        }
    },
    head: {
        style: {}
    },
    headRow: {
        style: {
            backgroundColor: 'var(--table-header-bg)',
            borderRadius: '12px 12px 0 0'
        }
    },
    rows: {
        style: {
            backgroundColor: 'var(--card-bg)',
            '&:nth-child(2n)': {
                backgroundColor: 'var(--table-row-hover)'
            },
            '&:last-child': {
                borderRadius: '0 0 12px 12px'
            }
        }
    },
    headCells: {
        style: {
            color: 'var(--table-header-text)',
            fontSize: '14px',
            fontWeight: '600',
            '&:not(:last-of-type)': {
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                borderRightColor: '#D4D3D3'
            }
        }
    },
    cells: {
        style: {
            fontSize: '14px',
            color: 'var(--table-cell-text)',
            '&:not(:last-of-type)': {
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                borderRightColor: '#D4D3D3'
            }
        }
    },
    progress: {
        style: {
            border: 'transparent'
        }
    }
};

/** Tablas de checklists: celdas con más aire y texto en varias líneas */
export const checklistTableStyles = {
    ...customInterspersedStyles,
    headCells: {
        ...customInterspersedStyles.headCells,
        style: {
            ...((customInterspersedStyles.headCells as { style?: Record<string, unknown> }).style || {}),
            paddingTop: '14px',
            paddingBottom: '14px',
            paddingLeft: '18px',
            paddingRight: '18px'
        }
    },
    rows: {
        ...customInterspersedStyles.rows,
        style: {
            ...((customInterspersedStyles.rows as { style?: Record<string, unknown> }).style || {}),
            minHeight: '80px'
        }
    },
    cells: {
        ...customInterspersedStyles.cells,
        style: {
            ...((customInterspersedStyles.cells as { style?: Record<string, unknown> }).style || {}),
            fontSize: '14px',
            color: 'var(--table-cell-text)',
            whiteSpace: 'normal',
            overflow: 'visible',
            verticalAlign: 'middle',
            paddingTop: '20px',
            paddingBottom: '20px',
            paddingLeft: '18px',
            paddingRight: '18px',
            '&:not(:last-of-type)': {
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                borderRightColor: '#D4D3D3'
            }
        }
    }
};
